// Based on this: https://w3bits.com/css-grid-masonry/ and https://medium.com/@andybarefoot/a-masonry-style-layout-using-css-grid-8c663d355ebb
const resizeMasonryItem = (item) => {
  const grid = document.getElementsByClassName('masonry')[0]

  if (!grid || !item) {
    return
  }
  // finds the height of the rows and the vertical gap between rows.
  // Now we know the height of each row and gap we can calculate the number of rows
  // required to accommodate the height of the item content.
  const rowGap = parseInt(
    window.getComputedStyle(grid).getPropertyValue('grid-row-gap')
  )
  const rowHeight = parseInt(
    window.getComputedStyle(grid).getPropertyValue('grid-auto-rows')
  )

  const content = item.querySelector('.masonry-content')
  if (!content) {
    return
  }
  const rowSpan = Math.ceil(
    (content.getBoundingClientRect().height + rowGap) / (rowHeight + rowGap)
  )

  item.style.gridRowEnd = 'span ' + rowSpan
}

export default resizeMasonryItem
